import React, { useEffect } from "react";
import Farm_vdo from "../home/farm_vdo/Farm_vdo";
import About_Info from "./about_Info/About_Info";
import About_us_card_content from "./about_us_card_content/About_us_card_content";
import Achievements_and_acknowledgments from "./achievements_and_acknowledgments/Achievements_and_acknowledgments";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import Founding_farmers from "./founding_farmers/Founding_farmers";
import { useDispatch, useSelector } from "react-redux";
import {
  getAboutUs,
  getAch_and_ack,
  getContent,
} from "../../features/aboutus/aboutusSlice";
import OurJourney from "./ourJourney/OurJourney";
import WhyLoveUs from "./whyLoveUs/WhyLoveUs";

function About_us() {
  const about_us = useSelector((state) => state.aboutus.about_us);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const ach_and_ack = useSelector((state) => state.aboutus.ach_and_ack);

  useEffect(() => {
    dispatch(getAch_and_ack());
  }, [dispatch]);
  return (
    <>
      <Farm_vdo about_us={about_us} />
      {/* <About_Info about_us={about_us} /> */}
      <OurJourney about_us={about_us} />
      {/* <WhyLoveUs /> */}
      {/* <About_us_card_content />
      {ach_and_ack?.data?.length > 0 && (
        <Achievements_and_acknowledgments ach_and_ack={ach_and_ack} />
      )}

      <Founding_farmers /> */}
      {/* <Stay_Connected /> */}
    </>
  );
}

export default About_us;
